export function openCloseAddress() {
    var openCloseContainer = $(".offer-item");
    var itemButton = openCloseContainer.find(".link-more:not(.map-link)");

    itemButton.on("click", function (e) {
        var elem = $(this);
        var elemContainer = elem.closest(".offer-item");

        if (!elemContainer.hasClass("show")) {
            $(elemContainer).siblings(".offer-item").removeClass("show");
        }
        elemContainer.toggleClass("show");

        return false;
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/openCloseAddress.js